<div  id  = "menu-icon-container" class="pd-bgc">
  <img src = "./assets/images/logos/logo.png" class = "w-100 px-3" >
</div>

<mat-divider></mat-divider>

<div id="menu-item-container" class="mt-4">
  <menu-item *ngFor="let item of items" [item]="item" (clickOnItem)="itemClicked($event)"></menu-item>
</div>

<mat-divider></mat-divider>

<div id = "version" class = "text-center my-2">
  webapp version {{getCurrentVersion()}}
</div>